<app-media-upload
    [media]="video"
    (mediaChange)="handleFileUploadSuccess($event)"
    (mediaSoftDelete)="handleFileUploadSoftDelete($event)"
    [acceptedTypes]="acceptedTypes"
    [uploadMethod]="uploadFile"
>
    <div data-mediaInfos class="app-media-upload__infos">
        <mat-icon svgIcon="info"></mat-icon>
        <span>{{ 'generic.format_ratio' | translate }}</span> -- <span>{{ 'generic.format_max_media_upload' | translate }}</span>
    </div>
    <div  data-mediaInfosUploadSuccess class="app-media-upload__infos-success" >
        <mat-icon svgIcon="info"></mat-icon>
        <span>{{ 'generic.video-upload-success' | translate }}</span>
    </div>
    <div data-mediaDeleteWarningInfos class="app-media-upload__infos-delete-warning">
        <mat-icon svgIcon="info"></mat-icon>
        <span>{{ 'generic.delete_warning_video' | translate }}</span>
    </div>

    <video data-media [src]="video?.uri" [controls]="false"></video>
</app-media-upload>